// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"90c2cdcc","703":"c6e34718","787":"b1de939b"}[chunkId] + ".chunk.js";
};